import type { ConnectToForgeParameters } from '../types';

export function getConnectMacroId(parameters: ConnectToForgeParameters): string | undefined {
	return parameters?.macroMetadata?.macroId?.value;
}
